module.exports = __webpack_public_path__ + "img/Return-min.99b03ded.png";